<script>
export default {
  name: "CheatingCheckForm",
  props:{
    cheating:{
      type: Object,
      default(){
        return null
      }
    },
    isView:{
      type: Boolean,
      default(){
        return false
      }
    }
  },
  data(){
    return {
      options:[
        {
          label: 'Từ 30% tới 50%',
          value: 0,
        },
        {
          label: 'Từ 50% trở lên',
          value: 1,
        }
      ]
    }
  }
}
</script>

<template>
<div v-if="cheating?.isCheating !==null && cheating?.PlagiarismRate!==undefined && cheating?.comment!==null">
  <p>Bài viết có dấu hiệu đạo văn không?</p>
  <el-radio v-model="cheating.isCheating" :label="false" :disabled="isView">Không</el-radio>
  <br>
  <el-radio v-model="cheating.isCheating" :label="true" :disabled="isView">Có</el-radio>
  <div v-if="cheating?.isCheating">
    <p>Tỉ lệ đạo văn của bài viết <span style="color: red">*</span></p>

    <el-select v-model="cheating.PlagiarismRate" placeholder="Chọn tỉ lệ đạo văn" size="medium " :disabled="isView">
      <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
    <p class="mt-4">Nhận xét cụ thể, dẫn chứng <span style="color: red">*</span></p>

    <el-input
        style="width: 100%"
        type="textarea"
        :rows="2"
        placeholder="Nhận xét"
        v-model="cheating.comment" :disabled="isView">
    </el-input>
  </div>
</div>
</template>

<style scoped>

</style>